import Axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import store from '../../redux/store';

export default class HttpService {
    private static axiosCustomInstance(): AxiosInstance {
        return Axios.create();
    }

    static get<T = any, R = AxiosResponse<T>>(
        apiUrl: string,
        config?: AxiosRequestConfig
    ): Promise<R> {
        return this.axiosCustomInstance().get(apiUrl, {
            ...config,
            headers: HttpService.getAuthHeader(),
        });
    }

    static post<T = any, R = AxiosResponse<T>>(
        apiUrl: string,
        data?: any,
        config?: AxiosRequestConfig
    ): Promise<R> {
        return this.axiosCustomInstance().post(apiUrl, data, {
            ...config,
            headers: HttpService.getAuthHeader(),
        });
    }

    static delete<T = any, R = AxiosResponse<T>>(
        apiUrl: string,
        config?: AxiosRequestConfig
    ): Promise<R> {
        return this.axiosCustomInstance().delete(apiUrl, {
            ...config,
            headers: HttpService.getAuthHeader(),
        });
    }

    static put<T = any, R = AxiosResponse<T>>(
        apiUrl: string,
        data?: any,
        config?: AxiosRequestConfig
    ): Promise<R> {
        return this.axiosCustomInstance().put(apiUrl, data, {
            ...config,
            headers: HttpService.getAuthHeader(),
        });
    }

    static buildQueryParams(params: any) {
        const qs: string[] = [];
        for (const key in params) {
            if (Object.prototype.hasOwnProperty.call(params, key)) {
                qs.push(
                    `${encodeURIComponent(key)}=${encodeURIComponent(
                        params[key]
                    )}`
                );
            }
        }
        return `?${qs.join('&')}`;
    }

    static getAuthHeader() {
        const token = localStorage.getItem('token');
        const { sideBarReducer } = store.getState();
        const { companyDetails }: any = sideBarReducer;
        return {
            Authorization: 'Bearer ' + token,
            'company-id': companyDetails?.companyId || '',
            // "Accept":"application/json"
        };
    }
}
